<template>
  <div class="swiper-container">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(item,index) in banners" :key="index">
        <component v-bind:is="item" :options="options" :ref="item"></component>
      </div>
    </div>
    <div class="content-overlay" v-show="goodNewsStatus">
      <div class="goodNews">
        <img src="../assets/goodNews.png" class="news-background"/>
        <img class="avatar" :src="info.avatar"/>
        <span class="name">{{ info.name }}</span>
        <span class="tips">恭喜成交新订单!</span>
        <span class="count">{{detailInfo.symbol}}{{info.amount}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/css/swiper.min.css'
import latestDeal from './latestDeal.vue';
import quantityRanking from './quantityRanking.vue';
import numberRanking from './numberRanking.vue';
import monthQuantityRanking from './monthQuantityRanking.vue';
import monthNumberRanking from './monthNumberRanking.vue';
import completeness from './completeness.vue';
import countryTime from './time.vue';

export default {
  data() {
    return {
      swiper: '',
      stayTime: 10,
      info:{},
      goodNewsStatus: false
    }
  },
  props:['banners', 'options', 'detailInfo'],
  components:{
    latestDeal,
    quantityRanking,
    numberRanking,
    monthQuantityRanking,
    monthNumberRanking,
    completeness,
    countryTime
  },
  methods:{
    init(stayTime) {
      // let _this = this;
      this.stayTime = stayTime;
      this.swiper = new Swiper('.swiper-container', {
        loop:true, //是否循环轮播
        autoplay: {
          delay: stayTime * 1000
        },
        disableOnInteraction: false,
        observer:true,
        observeParents:false,
        on: {
            slideChangeTransitionEnd() {
              this.slideToLoop(this.realIndex, 0, true);
            }
        }
      })
    },
    clearGoodNews(){
      this.goodNewsStatus = false;
    },
    changeSwiper(result) {
      this.swiper.slideTo(1, 1000);
      setTimeout(()=> {
        this.init(this.stayTime)
      }, 21000)
      if(result){
        this.info = result;
        this.goodNewsStatus = true;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .audioBtn{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: black;
    position: absolute;
    right: 40px;
    top: 40px;
    color: white;
    text-align: center;
  }
  .content-overlay{
    position: absolute;
    z-index: 50;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* 半透明灰色 */
    .goodNews{
      position: absolute;
      width: 410px;
      height: 730px;
      top: 50%;           /* 子元素距离父元素顶部50% */
      left: 50%;          /* 子元素距离父元素左边50% */
      transform: translate(-50%, -50%); /* 通过transform将子元素向上和向左各移动自身宽高的50%，实现居中 */
      z-index:9999;
      .news-background{
        width: 100%;
      }
      .avatar{
        top: 229px;
        left: 125px;
        width: 160px;
        height: 160px;
        border-radius: 50%;
        position: absolute;
      }
      .name{
        position: absolute;
        color: #F56C6C;
        font-size: 22px;
        display: inline-block;
        width: 100%;
        top: 392px;
        left: 0;
        text-align: center;
        font-weight: 600;
      }
      .tips{
        color: #f5c379;
        font-size: 20px;
        display: inline-block;
        width: 100%;
        text-align: center;
        position: absolute;
        top: 485px;
        left: 0;
      }
      .count{
        color: #f5c379;
        top: 535px;
        font-size: 35px;
        display: inline-block;
        width: 100%;
        text-align: center;
        position: absolute;
        left: 0;
        font-weight: 600;
      }
    }
  }
</style>
